import { MenuItemInterface } from '../interfaces/menu.interface';
import { Roles } from '../utils/enums';

export function getMenuItemsList(userRoles: Roles[] = []): MenuItemInterface[] {
  return [
    {
      path: '/dashboard',
      text: 'MainComponent.home',
      icon: 'grid-outline',
      showOnSideBar: true,
      showOnDashboard: false,
      match: ['dashboard'],
      active: false
    },
    {
      path: '/help-center',
      text: 'MainComponent.menuItemsHelpCenter',
      icon: 'options-outline',
      showOnSideBar: userRoles.includes(Roles.ADMIN),
      showOnDashboard: userRoles.includes(Roles.ADMIN),
      match: ['help-center'],
      active: false
    },
    {
      path: '/user-management',
      text: 'MainComponent.menuItemsUsers',
      icon: 'people-outline',
      showOnSideBar: userRoles.some(role => [Roles.ADMIN, Roles.SUPPORT].includes(role)),
      showOnDashboard: userRoles.some(role => [Roles.ADMIN, Roles.SUPPORT].includes(role)),
      match: ['user-management'],
      active: false
    },
    // {
    //   path: '/insights',
    //   text: 'MainComponent.menuItemsInsights',
    //   icon: 'stats-chart-outline',
    //   showOnSideBar: true,
    //   showOnDashboard: true,
    //   match: ['insights'],
    //   active: false
    // },
    {
      path: '/grant-management',
      text: 'MainComponent.menuItemsGrants',
      icon: 'ribbon-outline',
      showOnSideBar: userRoles.includes(Roles.ADMIN),
      showOnDashboard: userRoles.includes(Roles.ADMIN),
      match: ['grant-management'],
      active: false
    },
    {
      path: '/impersonate',
      text: 'MainComponent.impersonate',
      icon: 'person-outline',
      showOnSideBar: false,
      showOnDashboard: true,
      match: ['impersonate'],
      active: false
    },
    {
      path: '/welcome-video-management',
      text: 'MainComponent.menuWelcomeVideoManagement',
      icon: 'play-circle-outline',
      showOnSideBar: userRoles.includes(Roles.ADMIN),
      showOnDashboard: userRoles.includes(Roles.ADMIN),
      match: ['welcome-video-management'],
      active: false
    }
  ];
}

export const menuItemsListForSecurity: MenuItemInterface[] = [
  {
    path: '/dashboard',
    text: 'MainComponent.home',
    icon: 'grid-outline',
    showOnSideBar: true,
    showOnDashboard: false,
    match: ['dashboard'],
    active: false
  }
];
